import React, { useState } from "react";
import styles from "../Table.module.css";
import Spinner from "../Spinner";
import Select from "react-select";

const selectStyle1 = {
  control: (base) => ({
    ...base,
    height: "38px",
    width: "100%",
    minHeight: "32px",
    zIndex: "10",
    margin: "5px 0px",
  }),

  placeholder: (base) => ({
    ...base,
    color: "#aaa",
    fontStyle: "italic",
    display: "none",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "blue"
      : state.isFocused
      ? "lightblue"
      : "white",
    color: state.isSelected ? "white" : "black",
    padding: "6px",
    fontSize: "12px",
    whiteSpace: "normal", // Allows text to wrap instead of truncating
    textOverflow: "unset", // Removes ellipsis
    overflow: "visible", // Ensures full visibility of text
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "12px",
    padding: "2px 2px 2px 0px", // Decreases padding inside the input box
    whiteSpace: "normal", // Allows full text to display
    textOverflow: "unset", // Removes ellipsis
    overflow: "visible", // Ensures full visibility of text
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    marginTop: "5px",
    zIndex: 999,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "100px", // Ensures the dropdown has a scrollable height
    overflowY: "auto", // Enables scrolling for overflow
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
    svg: {
      width: "12px",
      height: "12px",
    },
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0px",
  }),
};

const tableHeaders = {
  sample: [
    "Sr.No.",
    "Item Details",
    "T. Wt",
    "Gr Wt.",
    "St Wt",
    "D. Wt",
    "Nt Wt",
    "Fine %",
    "Wastage %",
    "F + W Wt.",
    "Rate/Gm",
    "St Amt",
    "Qty",
    "Pieces",
    "Hallmark Amt",
    "T Item Amt",
    "Packing Wt",
    "Dia Wt",
    "MRP",
    "URD Amt",
  ],
  return: [
    "Sr.No.",
    "Item Details",
    "T. Wt",
    "Gr Wt.",
    "St Wt",
    "D. Wt",
    "Nt Wt",
    "Fine %",
    "Wastage %",
    "F + W Wt.",
    "Rate/Gm",
    "St Amt",
    "Qty",
    "Pieces",
    "Hallmark Amt",
    "T Item Amt",
    "Packing Wt",
    "Dia Wt",
    "MRP",
    "URD Amt",
    "Description",
  ],
  receive_stone: [
    "Stone Name",
    "Shape",
    "Colour",
    "Size",
    "Pcs",
    "Weight",
    "Rate/GM",
    "Rate/Pcs",
    "Amount",
    "Description",
    "Delete Icon",
  ],
  receive_diamond: [
    "Diamond Name",
    "Shape",
    "Clarity",
    "Colour",
    "Slive",
    "Size",
    "Weight",
    "Rate",
    "Amount",
    "Description",
    "Delete Icon",
  ],
};

const ReceiveTab = ({ selectedCustomer, selectedOption }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [receiveList, setReceiveList] = useState([]);

  return (
    <div>
      <div className={styles.tableContainer}>
        <div style={{ display: "flex", gap: "20px" }}>
          <div className={styles.formGroup} style={{ width: "12%" }}>
            <label style={{ marginBottom: "5px" }}>Transaction Type</label>
            <Select className={styles["summary-select"]} styles={selectStyle1}>
              {selectedOption == "sample" && (
                <option selected>sample out</option>
              )}
              <option value="">-- select --</option>
              {/* {getPaymentModeOptions().map((item) => (
                <option key={item?.value} value={item?.value}>
                  {item?.label}
                </option>
              ))} */}
            </Select>
          </div>
          <div className={styles.formGroup} style={{ width: "12%" }}>
            <label style={{ marginBottom: "5px" }}>Transaction No.</label>
            <Select
              // {...register("paymentMode")}
              className={styles["summary-select"]}
              styles={selectStyle1}
            >
              <option value="">-- select --</option>
              {/* {getPaymentModeOptions().map((item) => (
                <option key={item?.value} value={item?.value}>
                  {item?.label}
                </option>
              ))} */}
            </Select>
          </div>
          <div className={styles.formGroup} style={{ width: "16%" }}>
            <label style={{ marginBottom: "7px" }}>Description</label>
            <input
              // {...register("paymentDescription")}
              style={{
                width: "100%",
                height: "35px",
                outline: "1px solid #ccc",
                marginTop: "6px",
              }}
              className={styles["summary-input"]}
              type="text"
            />
          </div>
        </div>
        <table className={styles.table}>
          <thead>
            <tr>
              {tableHeaders[selectedOption]?.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td
                  colSpan={tableHeaders[selectedOption]?.length}
                  style={{
                    padding: "20px",
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <Spinner />
                    <span>Loading data...</span>
                  </div>
                </td>
              </tr>
            ) : receiveList && receiveList.length > 0 ? (
              receiveList.map((item, index) => (
                <tr key={item.id || index}>
                  <td>{index + 1}</td>
                  <td>{item.date || "-"}</td>
                  <td>{item.itemDetails || "-"}</td>
                  {selectedOption === "sample" ||
                  selectedOption === "return" ? (
                    <>
                      <td>{item.grossWt || "0"}</td>
                      <td>{item.netWt || "0"}</td>
                      <td>{item.finePercentage || "0"}</td>
                      <td>{item.fineWt || "0"}</td>
                      <td>{item.rate || "0"}</td>
                      <td>{item.amount || "0"}</td>
                      <td>{item.description || "-"}</td>
                    </>
                  ) : selectedOption === "receive_stone" ? (
                    <>
                      <td>{item.stoneWt || "0"}</td>
                      <td>{item.stonePcs || "0"}</td>
                      <td>{item.rate || "0"}</td>
                      <td>{item.amount || "0"}</td>
                      <td>{item.description || "-"}</td>
                    </>
                  ) : (
                    <>
                      <td>{item.diamondWt || "0"}</td>
                      <td>{item.diamondPcs || "0"}</td>
                      <td>{item.rate || "0"}</td>
                      <td>{item.amount || "0"}</td>
                      <td>{item.description || "-"}</td>
                    </>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={tableHeaders[selectedOption]?.length}>
                  No Data Available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReceiveTab;
